import { render, staticRenderFns } from "./modalSugerenciaPrecio.vue?vue&type=template&id=338c570c&scoped=true"
import script from "./modalSugerenciaPrecio.vue?vue&type=script&lang=js"
export * from "./modalSugerenciaPrecio.vue?vue&type=script&lang=js"
import style0 from "./modalSugerenciaPrecio.vue?vue&type=style&index=0&id=338c570c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c570c",
  null
  
)

export default component.exports